import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
import styles from './FeedeskPricingContent.module.css';

const fadeInUp = {
  hidden:  { opacity: 0, y: 40 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.7 } },
};

const plans = [
  {
    name: 'Starter',
    price: '₹0',
    period: '/month',
    desc: 'For small tuition centers moving off spreadsheets.',
    highlight: false,
    features: [
      'Up to 30 students',
      'Manual payment recording',
      'Basic defaulter list',
      'PDF receipt generation',
      'Email support',
    ],
  },
  {
    name: 'Standard',
    price: '₹1,499',
    period: '/month',
    desc: 'For growing academies that need automation.',
    highlight: true,
    badge: 'Most Popular',
    features: [
      'Up to 150 students',
      'UPI & online payment tracking',
      'Auto payment reminders',
      'Monthly collection reports',
      'Batch fee management',
      'Priority support',
    ],
  },
  {
    name: 'Premium',
    price: '₹3,999',
    period: '/month',
    desc: 'For large academies with full financial control.',
    highlight: false,
    features: [
      'Unlimited students',
      'Multi-batch support',
      'Annual statement export',
      'Custom fee categories',
      'Dedicated account manager',
      'WhatsApp reminders',
    ],
  },
];

const FeedeskPricingContent = ({ setIsRegisterOpen }) => {
  return (
    <section className={styles.pricingSection}>
      <motion.div
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true }}
        variants={fadeInUp}
        className={styles.sectionHeader}
      >
        <h2>Simple, Transparent Pricing</h2>
        <p>No hidden charges. Pick a plan that matches your academy's size.</p>
      </motion.div>

      <div className={styles.pricingGrid}>
        {plans.map((plan, index) => (
          <motion.div
            key={index}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
            variants={fadeInUp}
            transition={{ delay: index * 0.15 }}
            className={`${styles.planCard} ${plan.highlight ? styles.featured : ''}`}
          >
            {plan.badge && (
              <div className={styles.popularBadge}>{plan.badge}</div>
            )}
            <div className={styles.planName}>{plan.name}</div>
            <div className={styles.planPrice}>
              {plan.price}
              <span className={styles.period}>{plan.period}</span>
            </div>
            <p className={styles.planDesc}>{plan.desc}</p>

            <ul className={styles.featureList}>
              {plan.features.map((f, i) => (
                <li key={i}>
                  <CheckCircle2 size={16} className={styles.checkIcon} />
                  {f}
                </li>
              ))}
            </ul>

            <button
              className={plan.highlight ? styles.btnPrimary : styles.btnGhost}
              onClick={() => setIsRegisterOpen(true)}
            >
              {plan.name === 'Starter' ? 'Start Free' : 'Get Started'}
            </button>
          </motion.div>
        ))}
      </div>
    </section>
  );
};

export default FeedeskPricingContent;